import React, { createContext, useContext, useState, useEffect } from "react";
import axiosConfig from "../Service/AxiosConfig";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [apiKey, setApiKey] = useState(null);


  const [location, setLocation] = useState(() => {
    const saved = localStorage.getItem("browsing_location");
    return saved
      ? JSON.parse(saved)
      : {
          browsing_address: "",
          browsing_lat: null,
          browsing_lng: null,
        };
  });

 
  useEffect(() => {
    localStorage.setItem("browsing_location", JSON.stringify(location));
  }, [location]);

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const res = await axiosConfig.get("/masters/googlemapkey/");
        setApiKey(res?.data?.results?.[0]?.key || null);
      } catch (err) {
        console.error("Failed to load Google API key", err);
      }
    };

    fetchApiKey();
  }, []);

 
  const detectLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by this browser.");
      return;
    }

    if (!apiKey) {
      alert("Location service not ready. Please try again.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
          );

          const data = await res.json();
          const address =
            data?.results?.[0]?.formatted_address || "";

          setLocation({
            browsing_address: address,
            browsing_lat: lat,
            browsing_lng: lng,
          });
        } catch (err) {
          console.error("Reverse geocoding failed", err);
        }
      },
      (error) => {
        console.error("Location permission denied or error:", error);
      }
    );
  };

  return (
    <LocationContext.Provider
      value={{
        addressModalOpen,
        setAddressModalOpen,
        location,
        setLocation,
        detectLocation,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext(LocationContext);
